import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import router_bhumie from './router_bhumie'
import './registerServiceWorker'





import VueHtmlToPaper from 'vue-html-to-paper';
 
const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css'
  ]
}

Vue.use(VueHtmlToPaper, options);
 



Vue.config.productionTip = false

import monev_navbar from './components/navbar/monev_navbar'
import monev_topbar   from './components/navbar/monev_topbar'
import monev_left_sidebar   from './components/navbar/monev_left_sidebar'

import body_atas   from './components/navbar/body_atas'
import body_bawah   from './components/navbar/body_bawah'

import monev_login   from './components/auth/monev_login.vue'
import monev_signin   from './components/auth/monev_signin.vue'
import tabel_1   from './components/monev/analisis/hasil_monev_bos/tabel_1.vue'
import tabel_2   from './components/monev/analisis/hasil_monev_bos/tabel_2.vue'
import tabel_3   from './components/monev/analisis/hasil_monev_bos/tabel_3.vue'
import tabel_4   from './components/monev/analisis/hasil_monev_bos/tabel_4.vue'
import tabel_5   from './components/monev/analisis/hasil_monev_bos/tabel_5.vue'


// SIDEBAR
import menu_registrasi from './components/navbar/menu_list/registrasi.vue'
import menu_planning from './components/navbar/menu_list/planning.vue'
import menu_office from './components/navbar/menu_list/office.vue'
import menu_sakip from './components/navbar/menu_list/sakip.vue'
import menu_simpeg from './components/navbar/menu_list/simpeg.vue'
// SIDEBAR

import bhumie_tab_pembuatan_tabel_blok from './components/bhumie/pendataan/persiapan/tab_pembuatan_znt/pembuatan_tabel_blok.vue'
import bhumie_tab_pembuatan_tabel_peta_znt from './components/bhumie/pendataan/persiapan/tab_pembuatan_znt/pembuatan_tabel_peta_znt.vue'
import bhumie_tab_perubahan_nir from './components/bhumie/pendataan/persiapan/tab_pembuatan_znt/perubahan_nir.vue'
import bhumie_tab_perubahan_znt_massal from './components/bhumie/pendataan/persiapan/tab_pembuatan_znt/perubahan_znt_massal.vue'
import bhumie_tab_perubahan_znt_terseleksi from './components/bhumie/pendataan/persiapan/tab_pembuatan_znt/perubahan_znt_terseleksi.vue'
import bhumie_tab_ac from './components/bhumie/pendataan/persiapan/tab_pembuatan_dbkb_standard/ac.vue'
import bhumie_tab_boiler from './components/bhumie/pendataan/persiapan/tab_pembuatan_dbkb_standard/boiler.vue'
import bhumie_tab_genset from './components/bhumie/pendataan/persiapan/tab_pembuatan_dbkb_standard/genset.vue'
import bhumie_tab_kolam_renang from './components/bhumie/pendataan/persiapan/tab_pembuatan_dbkb_standard/kolam_renang.vue'
import bhumie_tab_lap_tenis from './components/bhumie/pendataan/persiapan/tab_pembuatan_dbkb_standard/lap_tenis.vue'
import bhumie_tab_lift from './components/bhumie/pendataan/persiapan/tab_pembuatan_dbkb_standard/lift.vue'
import bhumie_tab_listrik from './components/bhumie/pendataan/persiapan/tab_pembuatan_dbkb_standard/listrik.vue'
import bhumie_tab_pabx from './components/bhumie/pendataan/persiapan/tab_pembuatan_dbkb_standard/pabx.vue'
import bhumie_tab_pagar from './components/bhumie/pendataan/persiapan/tab_pembuatan_dbkb_standard/pagar.vue'
import bhumie_tab_perkerasan from './components/bhumie/pendataan/persiapan/tab_pembuatan_dbkb_standard/perkerasan.vue'
import bhumie_tab_proteksi_api from './components/bhumie/pendataan/persiapan/tab_pembuatan_dbkb_standard/proteksi_api.vue'
import bhumie_tab_sumur_artesis from './components/bhumie/pendataan/persiapan/tab_pembuatan_dbkb_standard/sumur_artesis.vue'
import bhumie_tab_tangga_berjalan from './components/bhumie/pendataan/persiapan/tab_pembuatan_dbkb_standard/tangga_berjalan.vue'
import bhumie_tab_jpb_2 from './components/bhumie/pendataan/persiapan/tab_pembuatan_db_non_standard/jpb_2.vue'
import bhumie_tab_jpb_3 from './components/bhumie/pendataan/persiapan/tab_pembuatan_db_non_standard/jpb_3.vue'
import bhumie_tab_jpb_4 from './components/bhumie/pendataan/persiapan/tab_pembuatan_db_non_standard/jpb_4.vue'
import bhumie_tab_jpb_5 from './components/bhumie/pendataan/persiapan/tab_pembuatan_db_non_standard/jpb_5.vue'
import bhumie_tab_jpb_6 from './components/bhumie/pendataan/persiapan/tab_pembuatan_db_non_standard/jpb_6.vue'
import bhumie_tab_jpb_7 from './components/bhumie/pendataan/persiapan/tab_pembuatan_db_non_standard/jpb_7.vue'
import bhumie_tab_jpb_8A from './components/bhumie/pendataan/persiapan/tab_pembuatan_db_non_standard/jpb_8A.vue'
import bhumie_tab_jpb_8B from './components/bhumie/pendataan/persiapan/tab_pembuatan_db_non_standard/jpb_8B.vue'
import bhumie_tab_jpb_9 from './components/bhumie/pendataan/persiapan/tab_pembuatan_db_non_standard/jpb_9.vue'
import bhumie_tab_jpb_12 from './components/bhumie/pendataan/persiapan/tab_pembuatan_db_non_standard/jpb_12.vue'
import bhumie_tab_jpb_13 from './components/bhumie/pendataan/persiapan/tab_pembuatan_db_non_standard/jpb_13.vue'
import bhumie_tab_jpb_14 from './components/bhumie/pendataan/persiapan/tab_pembuatan_db_non_standard/jpb_14.vue'
import bhumie_tab_jpb_15 from './components/bhumie/pendataan/persiapan/tab_pembuatan_db_non_standard/jpb_15.vue'
import bhumie_tab_jpb_16 from './components/bhumie/pendataan/persiapan/tab_pembuatan_db_non_standard/jpb_16.vue'
import bhumie_tab_jpb_mezzanin from './components/bhumie/pendataan/persiapan/tab_pembuatan_db_non_standard/jpb_mezzanin.vue'
import bhumie_tab_spop from './components/bhumie/pendataan/objek_pajak/tab_SPOP_LSPOP/spop.vue'
import bhumie_tab_lspop from './components/bhumie/pendataan/objek_pajak/tab_SPOP_LSPOP/lspop.vue'

import bhumie_pemekaran_wilayah_tab1 from './components/bhumie/pendataan/pemekaran_wilayah/tab/pindah_kelurahan_keseluruhan.vue'
import bhumie_pemekaran_wilayah_tab2 from './components/bhumie/pendataan/pemekaran_wilayah/tab/gabung_beberapa_blok.vue'
import bhumie_pemekaran_wilayah_tab3 from './components/bhumie/pendataan/pemekaran_wilayah/tab/pindah_blok_keseluruhan.vue'
import bhumie_pemekaran_wilayah_tab4 from './components/bhumie/pendataan/pemekaran_wilayah/tab/pindah_nop.vue'

import bhumie_dhr_tab1 from './components/bhumie/pendataan/laporan/tab_dhr/dhr_ringkas.vue'
import bhumie_dhr_tab2 from './components/bhumie/pendataan/laporan/tab_dhr/laporan_data_op_ringkas.vue'
import bhumie_dhr_tab3 from './components/bhumie/pendataan/laporan/tab_dhr/laporan_dhr_urut_nop.vue'
import bhumie_dhr_tab4 from './components/bhumie/pendataan/laporan/tab_dhr/laporan_dhr_urut_noFormulir.vue'
import bhumie_dhr_tab5 from './components/bhumie/pendataan/laporan/tab_dhr/laporan_dhr_urut_nama.vue'
import bhumie_dhr_tab6 from './components/bhumie/pendataan/laporan/tab_dhr/rekap_objek_pajak.vue'
import bhumie_dhr_tab7 from './components/bhumie/pendataan/laporan/tab_dhr/laporan_perubahan_data_op.vue'
import bhumie_dhr_tab8 from './components/bhumie/pendataan/laporan/tab_dhr/laporan_sejarah_op.vue'
import bhumie_dhr_tab9 from './components/bhumie/pendataan/laporan/tab_dhr/laporan_rekapitulasi_op_desakecamatan.vue'
import bhumie_dhr_tab10 from './components/bhumie/pendataan/laporan/tab_dhr/laporan_nop_tidak_boleh_digunakan.vue'
import bhumie_dhr_tab11 from './components/bhumie/pendataan/laporan/tab_dhr/laporan_daftar_formulir_transaksi.vue'
import bhumie_dhr_tab12 from './components/bhumie/pendataan/laporan/tab_dhr/laporan_ringkas_pelengkap_data.vue'

import bhumie_laporan_penilaian_tab1 from './components/bhumie/penilaian/tab/daftar_op_dengan_nilai.vue'
import bhumie_laporan_penilaian_tab2 from './components/bhumie/penilaian/tab/rincian_perhitungan_penilaian.vue'
import bhumie_laporan_penilaian_tab3 from './components/bhumie/penilaian/tab/surat_keterangan_njop.vue'

import bhumie_penetapan_pencetakan_massal_tab1 from './components/bhumie/penetapan/tab_penetapan_pencetakan_massal/penetapan_massal.vue'
import bhumie_penetapan_pencetakan_massal_tab2 from './components/bhumie/penetapan/tab_penetapan_pencetakan_massal/cetak_massal.vue'

import bhumie_tab_simulasi_penetapan from './components/bhumie/penetapan/tab_simulasi_pencetakan_massal/simulasi_penetapan.vue'
import bhumie_tab_sppt from './components/bhumie/penetapan/tab_simulasi_pencetakan_massal/sppt.vue'

import bhumie_tab_laporan_tunggakan from './components/bhumie/penagihan/tab_daftar_tunggakan/laporan_tunggakan.vue'
import bhumie_tab_laporan_himpunan_tunggakan from './components/bhumie/penagihan/tab_daftar_tunggakan/laporan_himpunan_tunggakan.vue'
import bhumie_tab_laporan_tunggakan_perkecamatan from './components/bhumie/penagihan/tab_daftar_tunggakan/laporan_tunggakan_perkecamatan.vue'

import bhumie_tab_himbauan_biasa from './components/bhumie/penagihan/tab_pengeluaran_himbauan/himbauan_biasa.vue'
import bhumie_tab_himbauan_jemput_bola from './components/bhumie/penagihan/tab_pengeluaran_himbauan/himbauan_jemput_bola.vue'

import bhumie_tab_individu from './components/bhumie/pelayanan/input_permohonan/tab_input_permohonan/individu.vue'
import bhumie_tab_massal_kolektif from './components/bhumie/pelayanan/input_permohonan/tab_input_permohonan/massal_kolektif.vue'

import bhumie_tab_pendaftaran_objek_pajak_baru from './components/bhumie/pelayanan/adm_op_baru_mutasi/tab_adm_op_baru_mutasi/pendaftaran_objek_pajak_baru.vue'
import bhumie_tab_mutasi_objek_pajak_wajib_pajak from './components/bhumie/pelayanan/adm_op_baru_mutasi/tab_adm_op_baru_mutasi/mutasi_objek_pajak_wajib_pajak.vue'

import bhumie_tab_skpp from './components/bhumie/pelayanan/restitusi_kompensasi/tab_input_restitusi_kompensasi/skpp.vue'
import bhumie_tab_restitusi from './components/bhumie/pelayanan/restitusi_kompensasi/tab_input_restitusi_kompensasi/restitusi.vue'
import bhumie_tab_kompensasi from './components/bhumie/pelayanan/restitusi_kompensasi/tab_input_restitusi_kompensasi/kompensasi.vue'

import bhumie_kepegawaian_divisi   from './components/bhumie/referensi/kepegawaian/tab/divisi.vue'
import bhumie_kepegawaian_jabatan from './components/bhumie/referensi/kepegawaian/tab/jabatan.vue'
import bhumie_kepegawaian_pegawai from './components/bhumie/referensi/kepegawaian/tab/pegawai.vue'
import bhumie_kepegawaian_posisi_pegawai   from './components/bhumie/referensi/kepegawaian/tab/posisi_pegawai.vue'

import bhumie_tab_users from './components/bhumie/admin/tab_wewenang/users.vue'
import bhumie_tab_role_management from './components/bhumie/admin/tab_wewenang/role_management.vue'



import VueSweetalert2 from 'vue-sweetalert2';

Vue.component('app-monev_navbar', monev_navbar);
Vue.component('app-monev_topbar', monev_topbar);
Vue.component('app-monev_left_sidebar', monev_left_sidebar);


Vue.component('app-body_atas', body_atas);
Vue.component('app-body_bawah', body_bawah);

Vue.component('app-monev_login', monev_login);
Vue.component('app-monev_signin', monev_signin);

Vue.component('app-tabel_1', tabel_1);
Vue.component('app-tabel_2', tabel_2);
Vue.component('app-tabel_3', tabel_3);
Vue.component('app-tabel_4', tabel_4);
Vue.component('app-tabel_5', tabel_5);

// =============================================== NAVBAR ===============================================
Vue.component('menu_registrasi', menu_registrasi);
Vue.component('menu_planning', menu_planning);
Vue.component('menu_office', menu_office);
Vue.component('menu_sakip', menu_sakip);
Vue.component('menu_simpeg', menu_simpeg);
// =============================================== NAVBAR ===============================================


// =============================================== BHUMIE ===============================================

    Vue.component('bhumie_tab_pembuatan_tabel_blok', bhumie_tab_pembuatan_tabel_blok);
    Vue.component('bhumie_tab_pembuatan_tabel_peta_znt', bhumie_tab_pembuatan_tabel_peta_znt);
    Vue.component('bhumie_tab_perubahan_nir', bhumie_tab_perubahan_nir);
    Vue.component('bhumie_tab_perubahan_znt_massal', bhumie_tab_perubahan_znt_massal);
    Vue.component('bhumie_tab_perubahan_znt_terseleksi', bhumie_tab_perubahan_znt_terseleksi);

    Vue.component('bhumie_tab_ac', bhumie_tab_ac);
    Vue.component('bhumie_tab_boiler', bhumie_tab_boiler);
    Vue.component('bhumie_tab_genset', bhumie_tab_genset);
    Vue.component('bhumie_tab_kolam_renang', bhumie_tab_kolam_renang);
    Vue.component('bhumie_tab_lap_tenis', bhumie_tab_lap_tenis);
    Vue.component('bhumie_tab_lift', bhumie_tab_lift);
    Vue.component('bhumie_tab_listrik', bhumie_tab_listrik);
    Vue.component('bhumie_tab_pabx', bhumie_tab_pabx);
    Vue.component('bhumie_tab_pagar', bhumie_tab_pagar);
    Vue.component('bhumie_tab_perkerasan', bhumie_tab_perkerasan);
    Vue.component('bhumie_tab_proteksi_api', bhumie_tab_proteksi_api);
    Vue.component('bhumie_tab_sumur_artesis', bhumie_tab_sumur_artesis);
    Vue.component('bhumie_tab_tangga_berjalan', bhumie_tab_tangga_berjalan);

    Vue.component('bhumie_tab_jpb_2', bhumie_tab_jpb_2);
    Vue.component('bhumie_tab_jpb_3', bhumie_tab_jpb_3);
    Vue.component('bhumie_tab_jpb_4', bhumie_tab_jpb_4);
    Vue.component('bhumie_tab_jpb_5', bhumie_tab_jpb_5);
    Vue.component('bhumie_tab_jpb_6', bhumie_tab_jpb_6);
    Vue.component('bhumie_tab_jpb_7', bhumie_tab_jpb_7);
    Vue.component('bhumie_tab_jpb_8A', bhumie_tab_jpb_8A);
    Vue.component('bhumie_tab_jpb_8B', bhumie_tab_jpb_8B);
    Vue.component('bhumie_tab_jpb_9', bhumie_tab_jpb_9);
    Vue.component('bhumie_tab_jpb_12', bhumie_tab_jpb_12);
    Vue.component('bhumie_tab_jpb_13', bhumie_tab_jpb_13);
    Vue.component('bhumie_tab_jpb_14', bhumie_tab_jpb_14);
    Vue.component('bhumie_tab_jpb_15', bhumie_tab_jpb_15);
    Vue.component('bhumie_tab_jpb_16', bhumie_tab_jpb_16);
    Vue.component('bhumie_tab_jpb_mezzanin', bhumie_tab_jpb_mezzanin);

    Vue.component('bhumie_tab_spop', bhumie_tab_spop);
    Vue.component('bhumie_tab_lspop', bhumie_tab_lspop);

    Vue.component('bhumie_pemekaran_wilayah_tab1', bhumie_pemekaran_wilayah_tab1);
    Vue.component('bhumie_pemekaran_wilayah_tab2', bhumie_pemekaran_wilayah_tab2);
    Vue.component('bhumie_pemekaran_wilayah_tab3', bhumie_pemekaran_wilayah_tab3);
    Vue.component('bhumie_pemekaran_wilayah_tab4', bhumie_pemekaran_wilayah_tab4);

    Vue.component('bhumie_dhr_tab1', bhumie_dhr_tab1);
    Vue.component('bhumie_dhr_tab2', bhumie_dhr_tab2);
    Vue.component('bhumie_dhr_tab3', bhumie_dhr_tab3);
    Vue.component('bhumie_dhr_tab4', bhumie_dhr_tab4);
    Vue.component('bhumie_dhr_tab5', bhumie_dhr_tab5);
    Vue.component('bhumie_dhr_tab6', bhumie_dhr_tab6);
    Vue.component('bhumie_dhr_tab7', bhumie_dhr_tab7);
    Vue.component('bhumie_dhr_tab8', bhumie_dhr_tab8);
    Vue.component('bhumie_dhr_tab9', bhumie_dhr_tab9);
    Vue.component('bhumie_dhr_tab10', bhumie_dhr_tab10);
    Vue.component('bhumie_dhr_tab11', bhumie_dhr_tab11);
    Vue.component('bhumie_dhr_tab12', bhumie_dhr_tab12);

    Vue.component('bhumie_penetapan_pencetakan_massal_tab1', bhumie_penetapan_pencetakan_massal_tab1);
    Vue.component('bhumie_penetapan_pencetakan_massal_tab2', bhumie_penetapan_pencetakan_massal_tab2);

    Vue.component('bhumie_tab_simulasi_penetapan', bhumie_tab_simulasi_penetapan);
    Vue.component('bhumie_tab_sppt', bhumie_tab_sppt);

    Vue.component('bhumie_laporan_penilaian_tab1', bhumie_laporan_penilaian_tab1);
    Vue.component('bhumie_laporan_penilaian_tab2', bhumie_laporan_penilaian_tab2);
    Vue.component('bhumie_laporan_penilaian_tab3', bhumie_laporan_penilaian_tab3);

    Vue.component('bhumie_tab_laporan_tunggakan', bhumie_tab_laporan_tunggakan);
    Vue.component('bhumie_tab_laporan_himpunan_tunggakan', bhumie_tab_laporan_himpunan_tunggakan);
    Vue.component('bhumie_tab_laporan_tunggakan_perkecamatan', bhumie_tab_laporan_tunggakan_perkecamatan);

    Vue.component('bhumie_tab_himbauan_biasa', bhumie_tab_himbauan_biasa);
    Vue.component('bhumie_tab_himbauan_jemput_bola', bhumie_tab_himbauan_jemput_bola);

    Vue.component('bhumie_tab_individu', bhumie_tab_individu);
    Vue.component('bhumie_tab_massal_kolektif', bhumie_tab_massal_kolektif);

    Vue.component('bhumie_tab_pendaftaran_objek_pajak_baru', bhumie_tab_pendaftaran_objek_pajak_baru);
    Vue.component('bhumie_tab_mutasi_objek_pajak_wajib_pajak', bhumie_tab_mutasi_objek_pajak_wajib_pajak);

    Vue.component('bhumie_tab_skpp', bhumie_tab_skpp);
    Vue.component('bhumie_tab_restitusi', bhumie_tab_restitusi);
    Vue.component('bhumie_tab_kompensasi', bhumie_tab_kompensasi);

    Vue.component('bhumie_kepegawaian_divisi', bhumie_kepegawaian_divisi);
    Vue.component('bhumie_kepegawaian_jabatan', bhumie_kepegawaian_jabatan);
    Vue.component('bhumie_kepegawaian_pegawai', bhumie_kepegawaian_pegawai);
    Vue.component('bhumie_kepegawaian_posisi_pegawai', bhumie_kepegawaian_posisi_pegawai);

    Vue.component('bhumie_tab_users', bhumie_tab_users);
    Vue.component('bhumie_tab_role_management', bhumie_tab_role_management);

// =============================================== BHUMIE ===============================================


Vue.config.productionTip = false
Vue.use(VueSweetalert2);





import VueSession from 'vue-session'
Vue.use(VueSession)


/* eslint-disable no-new */
new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
